<template>
  <BaseModal>
    <template v-slot:modalContent>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Tipo Pessoa:</strong></label>
            <p id="id_personalidade_detalhe">{{ dado.personalidade }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>CPF/CNPJ:</strong></label>
            <p id="id_cpf_cnpj_detalhe">{{ dado.cpf_cnpj }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Nome Completo/Razão Social:</strong></label>
            <p id="id_razao_social_detalhe">{{ dado.razao_social }}</p>
          </div>
        </div>
        <div v-if="dado.fantasia" class="col-md-6">
          <div class="form-group">
            <label><strong>Nome Fantasia:</strong></label>
            <p id="id_fantasia_detalhe">{{ dado.fantasia }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>CEP:</strong></label>
            <p id="id_cep_detalhe">{{ dado.cep }}</p>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label><strong>Endereço:</strong></label>
            <p id="id_endereco_detalhe">{{ dado.endereco }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Número:</strong></label>
            <p id="id_numero_detalhe">{{ dado.numero }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Complemento:</strong></label>
            <p id="id_complemento_detalhe">{{ dado.complemento }}</p>
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label><strong>Bairro:</strong></label>
            <p id="id_bairro_detalhe">{{ dado.bairro }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Cidade:</strong></label>
            <p id="id_cidade_detalhe">{{ dado.cidade }}</p>
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-group">
            <label><strong>UF:</strong></label>
            <p id="id_uf_detalhe">{{ dado.uf }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Telefone:</strong></label>
            <p id="id_telefone_detalhe">{{ dado.telefone }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Celular:</strong></label>
            <p id="id_celular_detalhe">{{ dado.celular }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Data Nascimento:</strong></label>
            <p id="id_data_nascimento_detalhe">{{ dado.data_nascimento }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label><strong>Sexo:</strong></label>
            <p id="id_sexo_detalhe">{{ dado.sexo }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Profissão:</strong></label>
            <p id="id_profissao_detalhe">{{ dado.profissao }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Renda Bruta: </strong></label>
            <p id="id_renda_detalhe">{{ dado.renda }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Nacionalidade: </strong></label>
            <p id="id_nacionalidade_detalhe">{{ dado.nacionalidade }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Estado Civil:</strong></label>
            <p id="id_estado_civil_detalhe">{{ dado.estado_civil }}</p>
          </div>
        </div>
      </div>
      <!-- Se casado-->
      <div id="id_hidden" class="row" v-if="mostrarConjuge">
        <div id="div_tipo_uniao" class="col-md-3">
          <div class="form-group">
            <label><strong>Tipo União:</strong></label>
            <p id="id_tipo_uniao_detalhe">{{ dado.tipo_uniao }}</p>
          </div>
        </div>
        <div id="div_nome_conjuge" class="col-md-5">
          <div class="form-group">
            <label><strong>Nome Cônjuge:</strong></label>
            <p id="id_nome_conjuge_detalhe">{{ dado.nome_conjuge }}</p>
          </div>
        </div>
        <div id="div_cpf_conjuge" class="col-md-2">
          <div class="form-group">
            <label><strong>CPF Cônjuge:</strong></label>
            <p id="id_cpf_conjuge_detalhe">{{ dado.cpf_conjuge }}</p>
          </div>
        </div>
        <div id="div_renda_conjuge" class="col-md-2">
          <div class="form-group">
            <label><strong>Renda Bruta Cônjuge:</strong></label>
            <p id="id_renda_conjuge_detalhe">{{ dado.renda_conjuge }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Nome Mãe: </strong></label>
            <p id="id_nome_mae_detalhe">{{ dado.nome_mae }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><strong>Nome Pai:</strong></label>
            <p id="id_nome_pai_detalhe">{{ dado.nome_pai }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Pessoal:</strong></label>
            <p id="id_email_pessoal_detalhe">{{ dado.email_pessoal }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Comercial:</strong></label>
            <p id="id_email_comercial_detalhe">{{ dado.email_comercial }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label><strong>E-mail Financeiro:</strong></label>
            <p id="id_email_financeiro_detalhe">{{ dado.email_financeiro }}</p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label><strong>Status:</strong></label>
            <p id="id_status_detalhe" v-html="dado.status"></p>
          </div>
        </div>
      </div>
      <div class="ibox-footer">
        <button class="btn btn-success font-bold" @click="$emit('fechar')">
          Fechar
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "InformacoesCliente",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      mostrarConjuge: true,
      dado: 1,
      erro: null,
    };
  },
  emits: ['fechar'],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.clientes.retrieveUpdateDestroy(this.itemKey)}?modo=info`);
      if (resultado.success) {
        this.dado = resultado.data;
        if (this.dado.estado_civil !== 'CASADO') {
          this.mostrarConjuge = false;
        }
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
